import React from "react";
import {Group, Rect, Text} from "react-konva";
import {toHexColor} from "@modules/fields/utils/fieldColors.js";

// Fallback quando il campo non ha un colore configurato in FieldRegistry: lo stesso
// viola storico, distinto dagli stati gabbia (blu/giallo/rosso/verde).
const FILL = "#7c3aed";
const HEIGHT = 26;
const FONT = 15;
const PAD_X = 9;
const CHAR_W = 8.4;
const MAX_CHARS = 42;
const GAP = 4;

// Fallback nome campo dalla chiave normalizzata: "nome_prodotto" → "Nome prodotto".
function prettifyKey(k)
{
	const s = String(k || "").replace(/_/g, " ").trim();
	return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

/**
 * Tag "valore manuale" disegnati in alto a sinistra della gabbia (coordinate preview).
 * Un chip DISTINTO per ogni campo manuale, nel formato "Nome campo: valore"
 * (valore da `labels`, fallback su `overrides`; nome da `fieldNames`, fallback prettify).
 * Impilati verticalmente. Non intercettano gli eventi.
 */
export default function ManualZoneBadge({x, y, overrides, labels, fieldNames, fieldColors})
{
	const keys = overrides && typeof overrides === "object" ? Object.keys(overrides) : [];
	if (!keys.length)
		return null;

	const entries = keys.map(k =>
	{
		const raw = labels && labels[k] != null ? labels[k] : overrides[k];
		const value = (Array.isArray(raw) ? raw.join(", ") : String(raw ?? "")).trim();
		if (!value)
			return null;
		const name = (fieldNames && fieldNames[k]) || prettifyKey(k);
		return {key: k, text: `${name}: ${value}`};
	}).filter(Boolean);

	if (!entries.length)
		return null;

	return (
		<Group x={x + 3} y={y + 3} listening={false}>
			{entries.map((entry, i) =>
			{
				const text = entry.text.length > MAX_CHARS ? `${entry.text.slice(0, MAX_CHARS - 1)}…` : entry.text;
				const width = PAD_X * 2 + text.length * CHAR_W;
				const fill = toHexColor(fieldColors && fieldColors[entry.key], FILL);
				return (
					<Group key={entry.key} y={i * (HEIGHT + GAP)}>
						<Rect
							width={width}
							height={HEIGHT}
							cornerRadius={5}
							fill={fill}
							opacity={0.96}
							shadowColor="#000000"
							shadowBlur={3}
							shadowOpacity={0.3}
						/>
						<Text text={text} x={PAD_X} y={(HEIGHT - FONT) / 2} fontSize={FONT} fontStyle="bold" fill="#ffffff"/>
					</Group>
				);
			})}
		</Group>
	);
}
